export default __webpack_public_path__ + "static/media/no-car-image.3ca5aaf1.svg";